




























import { Component, Mixins } from 'vue-property-decorator';
import { DownloadListenerMixin } from './DownloadListenerMixin';
import { DownloadState } from '@/services/Downloads';

@Component({})
export class DownloadProgress extends Mixins(DownloadListenerMixin) {
	private get progressWidthPercent(): string {
		if (this.download?.progress !== undefined) {
			return `${this.download.progress}%`;
		}
		if (this.download?.state === DownloadState.failed) {
			return '100%';
		}
		return '0';
	}
}

export default DownloadProgress;
